export const NAV_SECTION_IDS = {
  Primary: 'primary',
  Modules: 'modules',
  Footer: 'footer',
} as const;

export const NAV_IDS = {
  Settings: 'settings',
  GetStarted: 'get-started',
  Home: 'home',
  Actions: 'actions',
  Agents: 'agents',

  People: 'people',
  Productivity: 'productivity',
  Learning: 'learning',
  Engagement: 'engagement',
  Documents: 'documents',
  Analytics: 'analytics',
  AnalyticsV2: 'analytics-v2',

  PeoplePulse: 'people-pulse',
  CareerPaths: 'career-paths',
  OrgStructure: 'org-structure',
  JobArchitecture: 'job-architecture',
  Locations: 'locations',
  Employees: 'employees',

  ProductivityPulse: 'productivity-pulse',
  Mgsa: 'mgsa',
  Okrs: 'okrs',
  Cycles: 'cycles',
  Tasks: 'tasks',
  Habits: 'habits',

  LearningPulse: 'learning-pulse',
  Library: 'library',
  Bookmark: 'bookmark',
  AllContent: 'all-content',
  MyRecents: 'my-recents',
  Collections: 'collections',
  QuestionBank: 'question-bank',
  Sessions: 'sessions',
  Assignment: 'assignment',
  Journeys: 'journeys',

  Surveys: 'surveys',
  Community: 'community',
  Meetings: 'meetings',
  OneOnOne: 'one-on-one',
  Praise: 'praise',
  Feedback: 'feedback',

  DocumentsLibraries: 'documents-libraries',
  DocumentsForYou: 'documents-for-you',
  DocumentsManage: 'documents-manage',

  AnalyticsV2Overview: 'analytics-v2-overview',
  AnalyticsV2Dashboards: 'analytics-v2-dashboards',
  AnalyticsV2Reports: 'analytics-v2-reports',
  AnalyticsV2Exports: 'analytics-v2-exports',
} as const;

export const NAV_GROUP_IDS = {
  PeopleMain: 'people-main',
  ProductivityOverview: 'productivity-overview',
  ProductivityOkrs: 'productivity-okrs',
  ProductivityPerform: 'productivity-perform',
  LearningOverview: 'learning-overview',
  LearningContent: 'learning-content',
  LearningDelivery: 'learning-delivery',
  EngagementMain: 'engagement-main',
  DocumentsMain: 'documents-main',
  AnalyticsV2Main: 'analytics-v2-main',
} as const;
